
import ChartComponent from "./ChartComponent";
import React from 'react';
import * as d3 from 'd3';

const HorizontalGridLines = ({ xScale, numberOfTicks, height, color = 'lightgrey', opacity = 0.25 }) => {
    function makeGridLines() {
        return d3.axisBottom(xScale).ticks(numberOfTicks).tickSize(-height).tickFormat("");
    }

    function draw(chart) {
        chart.append('g')
            .attr('stroke', color)
            .attr('opacity', opacity)
            .attr('transform', `translate(0, ${height})`)
            .call(makeGridLines());
    }

    return (
        <ChartComponent
            draw={draw}
        />
    )
}

export default HorizontalGridLines
